import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { FeatureTourStepEnum } from './feature-tour-step.enum';

@Injectable()
export class FeatureTourService {
  featureTourStepBS = new BehaviorSubject(null);
  readonly localStorageKey = `${this.alcmeonContextService.companyId}-feature-tour-step`;

  constructor(private alcmeonContextService: AlcmeonContextService) {
    const featureTourStep = localStorage.getItem(this.localStorageKey);
    this.featureTourStepBS.next(featureTourStep ?? FeatureTourStepEnum.FIRST_USE);

    this.featureTourStepBS.subscribe(value => {
      this.persistFeatureStep(value);
    });
  }

  setFeatureStep(step: FeatureTourStepEnum | null) {
    this.featureTourStepBS.next(step);
  }

  persistFeatureStep(step: FeatureTourStepEnum) {
    localStorage.setItem(this.localStorageKey, step);
  }
}
